import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { IngresosAsalariadooServidorpublicoModalComponent } from '../ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';
import { IngresostrabajadorindependienteModalComponent } from '../ingresos-trabajador-independiente-modal/ingresos-trabajador-independiente-modal.component';
import { BeneficiosIngresosNoGravados } from '../../beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_229';

declare var require: (filename: string) => any;
var BigNumber210 = require('bignumber.js');

BigNumber210.config({
  DECIMAL_PLACES: 3,
  EXPONENTIAL_AT: 100,
  FORMAT: {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.'
  }
});

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Lista ingresos por herencias, donaciones, divorcio o porción conyugal', listHelp: ['581'] }
];

const tableStructure = [
    {id: 'informante', title: 'Informante'}, 
    {id: 'origen', title: 'Origen información'}, 
    {id: 'conceptoNombre', title: 'Concepto'}, 
    {id: 'valor', title: 'Valor'},
];


class Form1 {
  id: number;
  idSugerida:number;
  porcentaje:string;
  valor:string;
  conceptoNombre:string;
  concepto:string;
  concIngGO:string;
  origen:string;
  informante:string;
  retencion:string;
  UVT13000:string;
  UVT3250:string;
  UVT6500:string;
  exento:string;
  UVT1625:string;
  controlSugeridaForm: ControlSugeridaForm;
}
class ControlSugeridaForm{
  numNitReportante: string;
  grupos:Array<ControlGrupoVariables>;
}
class ControlGrupoVariables{
  idGrupo:number;
  variable:string;
}

class IngresosDominio {
  valor: number;
  nombre: string;
  mostrar: boolean;
}

@Component({
  selector: 'app-ingresos-herencia-donacion-conyugal-modal',
  templateUrl: './ingresos-herencia-dona-conyugal-modal.component.html',
  styleUrls: ['./ingresos-herencia-dona-conyugal-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class IngresoHerenciaDonaConyugalModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstIngresoGO: IngresosDominio[] = [];
  public lstGOHerencia: IngresosDominio[] = [];
  public listaPorc: number[] = [];

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;
  casillaLimpiada1: boolean = false;
  casillaLimpiada2: boolean = false;

  saveModel = new EventEmitter();
  public showSave:boolean;
  tablaArt73:any;
  listaConcepIngresoGO: any;
  listaIngGOHerencia: any;
  model:DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema (basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  
  // public uvt: string = "42412"; //año 2023 unidad de valor tributario definida para el año para el cual se declara renta
  public uvt: string; //Soluciona uvt quemada $42412, se inyecta desde la sección ingresos


  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private _componentFactory: ComponentFactoryService,
    public dialogRef: MatDialogRef<IngresoHerenciaDonaConyugalModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    //console.log(this.model);
  }

  ngOnInit() {
    //this.model.doc.cuerpo.cc_id_582 = undefined;
    //this.inicializeModelo();
    //this.saveModel.emit(true);
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.validateShowSave();
    this.initializeListaPorc();
    
    this.listaIngGOHerencia = this.listaIngGOHerencia.map(item => ({...item, mostrar: true }));

    //console.log(this.listaIngGOHerencia);
    //console.log(this.model);

  }

  protected controlStep(direction: DirectionType): void {
  
  }

  limpiarValor() {
    if (this.modelForm.valor === '0' && !this.casillaLimpiada1) {
      this.modelForm.valor = null;
      this.casillaLimpiada1 = true;
    }
  }

  limpiarRetencion() {
    if (this.modelForm.retencion === '0' && !this.casillaLimpiada2) {
      this.modelForm.retencion = null;
      this.casillaLimpiada2 = true;
    }
  }
  

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.porcentaje="0";
    this.modelForm.valor="0";
    this.modelForm.conceptoNombre="";
    this.modelForm.concepto="0"
    this.modelForm.concIngGO='0';
    this.modelForm.origen="";
    this.modelForm.idSugerida=0;
    this.modelForm.informante="";
    this.modelForm.retencion="0";
    this.modelForm.UVT13000="0";
    this.modelForm.UVT3250="0";
    this.modelForm.UVT6500="0";
    this.modelForm.exento="0";
    this.modelForm.UVT1625="0";
    
}
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_582 == undefined){

      this.model.doc.cuerpo.cc_id_582 = []; //informante
      this.model.doc.cuerpo.cc_id_583 = []; //origen
      this.model.doc.cuerpo.cc_id_584 = []; //concepto
      this.model.doc.cuerpo.cc_id_591 = []; //concIngGO
      this.model.doc.cuerpo.cc_id_593 = []; //porcentaje
      this.model.doc.cuerpo.cc_id_585 = []; //valor
      this.model.doc.cuerpo.cc_id_594 = []; //retencion
      this.model.doc.cuerpo.cc_id_595 = [];
      this.model.doc.cuerpo.cc_id_597 = []; 
      this.model.doc.cuerpo.cc_id_596 = [];
      this.model.doc.cuerpo.cc_id_598 = [];
      this.model.doc.cuerpo.cc_id_576 = [];
      this.model.doc.cuerpo.cs_id_586 = "0";
   
    }  
  }

  public operacionCs586(){ 
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){

        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valor, suma);
    
    }
    if(suma)
    this.model.doc.cuerpo.cs_id_586 = suma;
    else
    this.model.doc.cuerpo.cs_id_586 = '0';
  }

  //Método que muestra o no items en la lista de listaIngGOHerencia
  protected reloadSelIngresosGO(){
    
    if(this.modelForm.concIngGO == "1" || this.modelForm.concIngGO == "2"){
      
      for (let i = 0; i < this.listaIngGOHerencia.length; i++) {
        if (i >=4 && i <= 6) {
          //console.log(i);
          this.listaIngGOHerencia[i].mostrar = false;
        }else{
          this.listaIngGOHerencia[i].mostrar = true;
        }

      }
    }else if(this.modelForm.concIngGO == "3"){
      for (let i = 0; i < this.listaIngGOHerencia.length; i++) {
        if ((i >=0 && i <= 3) || (i >=5 && i<= 6)) {
          //console.log(i);
          this.listaIngGOHerencia[i].mostrar = false;
        }else{
          this.listaIngGOHerencia[i].mostrar = true;
        }

      }
    }else if(this.modelForm.concIngGO == "4"){
      for (let i = 0; i < this.listaIngGOHerencia.length; i++) {
        if ((i >=0 && i <= 4) || (i == 6)) {
          //console.log(i);
          this.listaIngGOHerencia[i].mostrar = false;
        }else{
          this.listaIngGOHerencia[i].mostrar = true;
        }

      }
    }else if(this.modelForm.concIngGO == "5"){
      for (let i = 0; i < this.listaIngGOHerencia.length; i++) {
        if (i >=0 && i <= 5) {
          //console.log(i);
          this.listaIngGOHerencia[i].mostrar = false;
        }else{
          this.listaIngGOHerencia[i].mostrar = true;
        }

      }
    }

  }
 
 //Genera porcentaje de 1 a 100 
  protected initializeListaPorc(){

    for (let i = 1; i <= 100; i++) {
      this.listaPorc.push(i);
    }

}

  //limpia casilla
  onConceptoChange(newValue: string): void {
    if (newValue !== '1') {
      this.modelForm.porcentaje = "";
    }
  }

   
  private convertirPesosUvt(valorPesos) {
    valorPesos = this.dutilidades.deshacerFormatoMoneda(valorPesos);
    let valorOperacion = new BigNumber210(valorPesos);
    valorOperacion = valorOperacion.div(this.uvt);
    valorOperacion = valorOperacion.toFormat();
    const punto = valorOperacion.indexOf(".") + 1;
    if ((punto > 0) && (valorOperacion.length - punto) > 2)
      valorOperacion = valorOperacion.slice(0, -1);
    return String(valorOperacion);
  }
  
  //Límite 13000 UVT
  private operacionCas595(){
    
    const limUVT = "13000";
    const limPesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limUVT, true);
    
    let limUVTxPorc = "0";
    
    let porc = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION,this.modelForm.porcentaje.toString(),"100");

    //limUVTxPorc = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, limPesos, this.modelForm.porcentaje.toString());
    limUVTxPorc = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, limPesos, porc);

    if (this.modelForm.concepto == "1" && (this.modelForm.concIngGO == "1" || this.modelForm.concIngGO == "2")){

      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, limUVTxPorc, this.modelForm.valor)){
          //console.log("porc %: " + porc);
          //console.log("operacion= " + this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, limUVTxPorc, this.modelForm.valor));
    
          this.modelForm.UVT13000 = limUVTxPorc;
    
          /*console.log("concepto: " + this.modelForm.concepto);
          console.log("concIngGO: " + this.modelForm.concIngGO);
          console.log("limUVTxPorc: " + limUVTxPorc);
          console.log("UVT13000 <=: " + this.modelForm.UVT13000);*/

      }else{  
      
          this.modelForm.UVT13000 = this.modelForm.valor;
          //console.log("UVT13000 no cumple: " + this.modelForm.UVT13000);
      }
    }else{
      
      this.modelForm.UVT13000 = "0";
      //console.log("UVT13000 ultimo else: " + this.modelForm.UVT13000);
    }

    this.redondearFormData();

  }

  //Límite 6500 UVT
  private operacionCas596(){

    //if (this.modelForm.concepto !== "1" && this.modelForm.concepto !== "5"){
    //if (this.modelForm.concepto == "2"){
    //if ((this.modelForm.concepto == "1" || this.modelForm.concepto == "2") && (this.modelForm.concIngGO == "1")){
    if ((this.modelForm.concepto == "1" || this.modelForm.concepto == "2") && (this.modelForm.concIngGO == "1" || this.modelForm.concIngGO == "2")){
        
      const limUVT = "6500";
      const valorUVT = this.convertirPesosUvt(this.modelForm.valor);
      const limPesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limUVT, true);
      
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorUVT, limUVT)){
          
          //console.log(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorUVT, limUVT));
    
          this.modelForm.UVT6500 = this.modelForm.valor;
    
          //console.log("concepto: " + this.modelForm.concepto);
          //console.log("UVT6500 <= 6500 UVT: " + this.modelForm.UVT6500);

      }else{  
      
          this.modelForm.UVT6500 = limPesos;
          //console.log("concepto: " + this.modelForm.concepto);
          //console.log("UVT6500 > 6500 UVT: " + this.modelForm.UVT6500);
      }
    }else{
      
      this.modelForm.UVT6500 = "0";
      //console.log("concepto: " + this.modelForm.concepto);
      //console.log("UVT6500 no cumple condición: " + this.modelForm.UVT6500);
    }

    this.redondearFormData();

  }

  //Límite 3250 UVT
  private operacionCas597(){

    //if (this.modelForm.concepto == "5"){
    //if (this.modelForm.concepto == "4"){
    if ((this.modelForm.concepto == "1" || this.modelForm.concepto == "2" || this.modelForm.concepto == "4") && (this.modelForm.concIngGO == "1" || this.modelForm.concIngGO == "2")){
        
      const limUVT = "3250";
      const valorUVT = this.convertirPesosUvt(this.modelForm.valor);
      const limPesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limUVT, true);
      
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorUVT, limUVT)){
          
          //console.log(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorUVT, limUVT));
    
          this.modelForm.UVT3250 = this.modelForm.valor;
    
          //console.log("concepto: " + this.modelForm.concepto);
          //console.log("UVT3250: " + this.modelForm.UVT3250);

      }else{  
      
          this.modelForm.UVT3250 = limPesos;
          //console.log("concepto: " + this.modelForm.concepto);
          //console.log("UVT3250: " + this.modelForm.UVT3250);
      }
    }else{
      
      this.modelForm.UVT3250 = "0";
      //console.log("concepto: " + this.modelForm.concepto);
      //console.log("UVT3250: " + this.modelForm.UVT3250);
    }

    this.redondearFormData();

  }

  //Todo exento
  private operacionCas598(){

    //if (this.modelForm.concepto == "3"){
    if (this.modelForm.concepto == "3" || this.modelForm.concepto == "5"){

      //console.log("concepto: " + this.modelForm.concepto);

      this.modelForm.exento = this.modelForm.valor

      //console.log("exento: " + this.modelForm.exento);

    }else{
      this.modelForm.exento = "0";
    }

    this.redondearFormData();

  }

  //Limitante 1625 UVT o 20%
  private operacionCas576(){

    if (this.modelForm.concepto == "6" || this.modelForm.concepto == "7"){

      const limUVT = "1625";
      const valorX20 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valor, "0.2");
      const valorUVT = this.convertirPesosUvt(valorX20);
      const limPesos = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.uvt, limUVT, true);
      
      
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorUVT, limUVT)){
          
          //console.log(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, valorUVT, limUVT));
    
          this.modelForm.UVT1625 = valorX20;
    
          //console.log("concepto: " + this.modelForm.concepto);
          //console.log("UVT1625 valor 20%: " + this.modelForm.UVT1625);

      }else{  
      
          this.modelForm.UVT1625 = limPesos;
          //console.log("concepto: " + this.modelForm.concepto);
          //console.log("UVT1625 limite pesos: " + this.modelForm.UVT1625);
      }
    }else{
      
      this.modelForm.UVT1625 = "0";
      //console.log("concepto: " + this.modelForm.concepto);
      //console.log("UVT1625: " + this.modelForm.UVT1625);
    }

    this.redondearFormData();

  }

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 158:
        this.operacionCS158();
        break;
      
    }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";
  }
  
  operacionCS158(){
    this.model.doc.cuerpo.cs_id_158 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_158,true);
  }

  
  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_582.length; i++){
      this.modelForm.id=i;
      this.modelForm.informante=this.model.doc.cuerpo.cc_id_582[i].v;
      this.modelForm.origen=this.model.doc.cuerpo.cc_id_583[i].v;
      if(this.listaIngGOHerencia[this.model.doc.cuerpo.cc_id_584[i].v-1])
        this.modelForm.conceptoNombre=this.listaIngGOHerencia[this.model.doc.cuerpo.cc_id_584[i].v-1].nombre;
      this.modelForm.concepto=this.model.doc.cuerpo.cc_id_584[i].v;
      this.modelForm.concIngGO=this.model.doc.cuerpo.cc_id_591[i].v;
      this.modelForm.porcentaje=this.model.doc.cuerpo.cc_id_593[i].v;
      this.modelForm.valor=this.model.doc.cuerpo.cc_id_585[i].v;
      this.modelForm.retencion=this.model.doc.cuerpo.cc_id_594[i].v; 
      this.modelForm.UVT13000=this.model.doc.cuerpo.cc_id_595[i].v;
      this.modelForm.UVT3250=this.model.doc.cuerpo.cc_id_597[i].v;
      this.modelForm.UVT6500=this.model.doc.cuerpo.cc_id_596[i].v;
      this.modelForm.exento=this.model.doc.cuerpo.cc_id_598[i].v;
      this.modelForm.UVT1625=this.model.doc.cuerpo.cc_id_576[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
    this.operacionCs586();
  }

protected initializeTablaDesdeSugerida()
{
  let indexModel = this.model.doc.cuerpo.cc_id_582.length;
  
  if(indexModel==0)
  {
    const fieldsRecovery = ['VAR_2013','VAR_2486','VAR_3647','VAR_2014','VAR_2487','VAR_3648','VAR_1749','VAR_1750','VAR_1754'];
    ///Se elimina por solicitud funcional 11-09-2024,'VAR_2256_4'
    const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
    
    const grupos=[
      ['VAR_2013','VAR_2486','VAR_3647','VAR_2014','VAR_2487','VAR_3648'],
      ['VAR_1749','VAR_1750','VAR_1754']
    ];
    //////,'VAR_2256_4'
    
    if(resData){

      for(let i=0; i<resData.length; i++){
        for(let j=0; j<resData[i].item.value.length; j++){

          this.modelForm.id=indexModel;
          this.modelForm.informante=resData[i].item.numNitInformante[j]+"/"+resData[i].item.nomRazonSocialInformante[j];
          this.modelForm.concepto= "4";
          this.modelForm.conceptoNombre= this.listaIngGOHerencia[Number(this.modelForm.concepto)-1].nombre;
          if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, this.modelForm.valor, "0")) {
            this.modelForm.valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valor, "-1",true);
          }
          this.modelForm.origen="0";
          
          let itemGrupoFormPorEditar:Form1 = null;

          //0. Buscar el idGrupo al que corresponde la variable. (Siempre lo debe encontrar)
          let idGrupo:number = -1;
          for(let k=0;k<grupos.length;k++){
            if(grupos[k].includes(resData[i].key)){
              idGrupo=k;
              break;
            }
          }

          //1. El nit ya existe? NO ->1:Agregar
          if(this.dataSourceBody.find((el)=>{
            return el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]    
          })==undefined){
            itemGrupoFormPorEditar = null;
          }else{

            //2. Trae array de solo los del NIT
            let dataSourceBodyPorNitRep = this.dataSourceBody.filter((el)=>{
              if(el.controlSugeridaForm.numNitReportante == resData[i].item.numNitInformante[j]){
                return el;
              }
            });

            //3. Recorrer array de solo los del NIT
            for(let k=0;k<dataSourceBodyPorNitRep.length;k++){
              //En el registro existe una variable del GRUPO? 
              //  - NO: Debe Editar el registro y deja de buscar
              //  - SI: Siga buscando (al final si todos tienen entonces debe Agregar nuevo registro por que esta todo ocupado)
              let dataGrupo = dataSourceBodyPorNitRep[k].controlSugeridaForm.grupos.find((el=>{return el.idGrupo==idGrupo}));
              if(!dataGrupo){
                itemGrupoFormPorEditar = dataSourceBodyPorNitRep[k];
                break;
              }
            }

          }
          
          //4. Si la variable 'itemGrupoFormPorEditar' tiene valor entonces EDITA, si no AGREGA
          if(itemGrupoFormPorEditar){
            this.dataSourceBody = this.dataSourceBody.filter((itemModelForm)=>{
              if(itemModelForm.id == itemGrupoFormPorEditar.id){
                itemModelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
                itemModelForm = this.asignarVariablesSugeridasCondicionadas(itemModelForm, idGrupo, String(resData[i].item.value[j]));
              }
              return itemModelForm;
            });
          }else{
            this.modelForm.controlSugeridaForm = new ControlSugeridaForm();
            this.modelForm.controlSugeridaForm.numNitReportante = resData[i].item.numNitInformante[j];
            this.modelForm.controlSugeridaForm.grupos = new Array<ControlGrupoVariables>();
            this.modelForm.controlSugeridaForm.grupos.push({idGrupo:idGrupo,variable:resData[i].key});
            this.redondearFormData();
            this.modelForm = this.asignarVariablesSugeridasCondicionadas(this.modelForm, idGrupo, String(resData[i].item.value[j]));
            this.dataSourceBody.push(this.modelForm);
            this.inicializeForm();
            indexModel++;
          }

        }
      
      }
    }

  }
  this.operacionCs586();
}  

  private asignarVariablesSugeridasCondicionadas(itemModelForm: Form1, idGrupo:number, valor:string){
    switch(idGrupo){//Depende de la variable array grupos
      case 0:
        itemModelForm.valor=String(valor);
      break;
      case 1:
        itemModelForm.retencion=String(valor);
      break;
      default:
      break;
    }
    return itemModelForm;
  }

  public editModeloDesdeForm(){
   
    this.model.doc.cuerpo.cc_id_582[this.modelForm.id].v=this.modelForm.informante.toString();
    this.model.doc.cuerpo.cc_id_583[this.modelForm.id].v=this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_584[this.modelForm.id].v=this.modelForm.concepto.toString();
    this.model.doc.cuerpo.cc_id_591[this.modelForm.id].v=this.modelForm.concIngGO.toString();
    this.model.doc.cuerpo.cc_id_593[this.modelForm.id].v=this.modelForm.porcentaje.toString();
    this.model.doc.cuerpo.cc_id_585[this.modelForm.id].v=this.modelForm.valor.toString();
    this.model.doc.cuerpo.cc_id_594[this.modelForm.id].v=this.modelForm.retencion.toString();
    this.model.doc.cuerpo.cc_id_595[this.modelForm.id].v=this.modelForm.UVT13000.toString();
    this.model.doc.cuerpo.cc_id_597[this.modelForm.id].v=this.modelForm.UVT3250.toString();
    this.model.doc.cuerpo.cc_id_596[this.modelForm.id].v=this.modelForm.UVT6500.toString();
    this.model.doc.cuerpo.cc_id_598[this.modelForm.id].v=this.modelForm.exento.toString();
    this.model.doc.cuerpo.cc_id_576[this.modelForm.id].v=this.modelForm.UVT1625.toString();

    this.operacionCs586();
  
  }

  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    
    this.model.doc.cuerpo.cc_id_582.push({it: i, v:this.modelForm.informante});
    this.model.doc.cuerpo.cc_id_583.push({it: i, v:this.modelForm.origen.toString()});
    this.model.doc.cuerpo.cc_id_584.push({it: i, v:this.modelForm.concepto.toString()});
    this.model.doc.cuerpo.cc_id_591.push({it: i, v:this.modelForm.concIngGO.toString()});
    this.model.doc.cuerpo.cc_id_593.push({it: i, v:this.modelForm.porcentaje.toString()});
    this.model.doc.cuerpo.cc_id_585.push({it: i, v:this.modelForm.valor.toString()});
    this.model.doc.cuerpo.cc_id_594.push({it: i, v:this.modelForm.retencion.toString()});
    this.model.doc.cuerpo.cc_id_595.push({it: i, v:this.modelForm.UVT13000.toString()});
    this.model.doc.cuerpo.cc_id_597.push({it: i, v:this.modelForm.UVT3250.toString()});
    this.model.doc.cuerpo.cc_id_596.push({it: i, v:this.modelForm.UVT6500.toString()});
    this.model.doc.cuerpo.cc_id_598.push({it: i, v:this.modelForm.exento.toString()});
    this.model.doc.cuerpo.cc_id_576.push({it: i, v:this.modelForm.UVT1625.toString()});

    this.operacionCs586();

  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_582.splice(index,1);
    this.model.doc.cuerpo.cc_id_583.splice(index,1);
    this.model.doc.cuerpo.cc_id_584.splice(index,1);
    this.model.doc.cuerpo.cc_id_591.splice(index,1);
    this.model.doc.cuerpo.cc_id_593.splice(index,1);
    this.model.doc.cuerpo.cc_id_585.splice(index,1);
    this.model.doc.cuerpo.cc_id_594.splice(index,1);
    this.model.doc.cuerpo.cc_id_595.splice(index,1);
    this.model.doc.cuerpo.cc_id_597.splice(index,1);
    this.model.doc.cuerpo.cc_id_596.splice(index,1);
    this.model.doc.cuerpo.cc_id_598.splice(index,1);
    this.model.doc.cuerpo.cc_id_576.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_582.length;i++){
      this.model.doc.cuerpo.cc_id_582[i].it=i+1;
      this.model.doc.cuerpo.cc_id_583[i].it=i+1;
      this.model.doc.cuerpo.cc_id_584[i].it=i+1;
      this.model.doc.cuerpo.cc_id_591[i].it=i+1;
      this.model.doc.cuerpo.cc_id_593[i].it=i+1;
      this.model.doc.cuerpo.cc_id_585[i].it=i+1;
      this.model.doc.cuerpo.cc_id_594[i].it=i+1;
      this.model.doc.cuerpo.cc_id_595[i].it=i+1;
      this.model.doc.cuerpo.cc_id_597[i].it=i+1;
      this.model.doc.cuerpo.cc_id_596[i].it=i+1;
      this.model.doc.cuerpo.cc_id_598[i].it=i+1;
      this.model.doc.cuerpo.cc_id_576[i].it=i+1;

    }
    this.operacionCs586();
  }

  public validateFormCompleted():boolean{
    return this.modelForm.informante==undefined || this.modelForm.informante==null || this.modelForm.informante.trim()=="" ||
        this.modelForm.valor==undefined || this.modelForm.retencion==undefined || 
        this.modelForm.concepto==undefined || this.modelForm.concepto==null ||
        this.modelForm.origen==undefined || this.modelForm.origen==null 
  }

  public redondearFormData(){
    this.modelForm.valor=this.dutilidades.redondearValorMoneda(this.modelForm.valor.toString(),true);
    this.modelForm.retencion=this.dutilidades.redondearValorMoneda(this.modelForm.retencion.toString(),true);
    
  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
        if (this.operacionTabla==this.OPERACION_EDITAR){
        /*const existeValor = this.model.doc.cuerpo.cc_id_582.some(item => item.v === this.modelForm.informante);
      
        if(this.modelForm.origen=="2" || this.modelForm.origen=="1" || (existeValor && this.modelForm.origen=="0")){ //editando contribuyente o editando sugerida
          this.modelForm.origen = this.modelForm.origen=="0" && this.modelForm.origen=="0" ? "1" : this.modelForm.origen;
          this.editModeloDesdeForm();
        }else if(this.modelForm.origen=="0"){ //editando sugerida
          this.modelForm.origen = "1";
          this.modelForm.id = this.model.doc.cuerpo.cc_id_582.length;
          this.addToModeloDesdeForm();
        }*/
        this.modelForm.conceptoNombre = this.listaIngGOHerencia[Number(this.modelForm.concepto)-1].nombre;
        if(this.modelForm.origen=="0"){ 
          this.modelForm.origen = "1";
        }
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });

       }else if (this.operacionTabla==this.OPERACION_AGREGAR){ //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_582.length;
        this.modelForm.origen = "2";
        //this.modelForm.informante = "Contribuyente";
        this.modelForm.conceptoNombre = this.listaIngGOHerencia[Number(this.modelForm.concepto)-1].nombre;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs586();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs586();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelIngresosGO();
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs586();
    this.dialogRef.close("");
  }
  
  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
    //if(this.model.doc.cuerpo.cc_id_582.length != this.dataSourceBody.length){ 
    this.model.doc.cuerpo.cc_id_582 = undefined;
    this.inicializeModelo();
    
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm(); 
    }
        
    this.operacionCs586();
    
    this.saveModel.emit(true);

    this.closeModal();

  }
  
  public borrarTabla(){
    this.dataSourceBody = [];
  }


}


// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-herencia-donacion-conyugal-modal/ingresos-herencia-dona-conyugal-modal.component.ts